import { HoverPopper } from '..';

import type { AbsoluteHoverPopperProps } from '..';
import type { FC, ReactNode } from 'react';

export interface CascadingDropDownMenu extends AbsoluteHoverPopperProps {
  children: ReactNode;
}

export const CascadingDropDownMenu: FC<CascadingDropDownMenu> = ({
  children,
  placement = 'bottom',
  component,
  ...props
}) => (
  <HoverPopper placement={placement} component={component} {...props}>
    <div>{children}</div>
  </HoverPopper>
);
